const variables = {
  areaUnit: [
    {
      text: "Metros²",
      value: "metros",
    },
    {
      text: "Hectares",
      value: "hectare",
    },
    {
      text: "Alqueires",
      value: "alqueire",
    },
  ],
  purpose: [
    {
      text: "Pecuária",
      value: 1,
    },
    {
      text: "Lavoura",
      value: 2,
    },
    {
      text: "Pecuária e Lavoura",
      value: 3,
    },
    {
      text: "Incorporação",
      value: 4,
    },
  ],
  areaType: [
    {
      text: "Venda",
      value: 1,
    },
    {
      text: "Locação",
      value: 5,
    },
    {
      text: "Arrendamento",
      value: 2,
    },
    {
      text: "Parceria",
      value: 3,
    },
    {
      text: "Sales & Leaseback",
      value: 4,
    },
  ],
  propertyType: [
    {
      text: "Fazenda",
      value: 1,
    },
    {
      text: "Sítio",
      value: 2,
    },
    {
      text: "Chácara",
      value: 3,
    },
    {
      text: "Área de Mata",
      value: 4,
    },
    {
      text: "Perímetro Urbano",
      value: 5,
    },
    {
      text: "Apresentação",
      value: 6,
    },
  ],
  orderAreaType: [
    {
      text: "Compra",
      value: 1,
    },
    {
      text: "Arrendamento",
      value: 2,
    },
    {
      text: "Parceria",
      value: 3,
    },
    {
      text: "Aquisição de Leaseback",
      value: 4,
    },
  ],
  orderStatus: [
    {
      text: "Novo",
      value: 1,
    },
    {
      text: "Qualificado",
      value: 2,
    },
    {
      text: "Buscando Área",
      value: 3,
    },
    {
      text: "Em Negociação",
      value: 4,
    },
    {
      text: "Fechado",
      value: 5,
    },
    {
      text: "Perdido",
      value: 6,
    },
    {
      text: "Suspenso",
      value: 7,
    },
  ],
};

export default variables;
